import Swiper from "swiper";
import { Navigation } from "swiper/modules";

const articleRoot = document.querySelector(".articleSwiper");
if (articleRoot) {
	new Swiper(articleRoot, {
		slidesPerView: "auto",
		spaceBetween : 24,
		modules      : [ Navigation ],
		grabCursor   : false,
		navigation   : {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
	});
}
